import React from 'react'
import Style from './pageState.module.css'

const PageLoader = ({ message, fullScreen }) => (
    <div className={[Style.loader, fullScreen ? Style.loaderFullScreen : ''].join(' ')} role="status">
        <span className={Style.spinner} aria-hidden="true" />
        {message ? <span>{message}</span> : <span className="sr-only">Loading</span>}
    </div>
)

export default PageLoader
